<div class="absolute-center">
  <div class="fwe-d-flex fwe-flex-column fwe-flex-md-row">
    <div class="fwe-d-flex fwe-flex-column fwe-gap-4">
      <div data-smrtnc-test="error-component--heading" class="fwe-h1">{{ 'MISC.SERVICE_UNAVAILABLE_ERROR' | translate }}</div>
      <div>
        <div class="fwe-h3">{{ 'MISC.SERVICE_UNAVAILABLE_DESCRIPTION' | translate }}</div>
        @let code = appBootstrapErrorService.getHttpStatusCode();
        @if (code && code !== '0') {
          <div data-smrtnc-test="error-component--code" class="fwe-mt-2 fwe-color-control-active fwe-font-size-md">
            {{ 'MISC.SERVICE_UNAVAILABLE_STATUS_CODE' | translate: { code } }}
          </div>
        }
      </div>
    </div>

    <sma-web-app-error-page-robot />
  </div>

  <button data-smrtnc-test="error-component--retry-button" class="fwe-mt-5 fwe-btn fwe-btn-hero facade-page-button" (click)="retry()">
    {{ 'MISC.SERVICE_UNAVAILABLE_RETRY' | translate : { default: 'Retry' } }}
  </button>
</div>

